<template>
    <v-lazy v-model="isActive">
        <span :class="flexClass">
            <span class="d-flex flex-nowrap align-center">
                <CalcStatChip
                    :class="_noLeftMargin ? 'ml-0' : ''"
                    :value="totalProjects.val"
                    :loaded="totalProjects.loaded"
                    color="#ffddee"
                    icon="mdi-domain"
                    tooltip="Total projects"
                />
                <CalcStatChip
                    :value="uniqueUsers"
                    :loaded="loaded"
                    color="#FFF780"
                    icon="mdi-account-outline"
                    tooltip="Unique users"
                />
            </span>
            <span class="d-flex flex-nowrap align-center" style="width: '100%'">
                <CalcStatChip
                    :value="totalUsage"
                    :loaded="loaded"
                    color="#e0e0e0"
                    icon="mdi-chart-line-variant"
                    tooltip="Total usage"
                />
            </span>
        </span>
    </v-lazy>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import CalcStatChip from './CalcStatChip.vue'

const props = defineProps({
    calcId: { type: Number },
    noLeftMargin: { type: Boolean },
    manuallySetVals: { type: Boolean },
    manualLoading: { type: Boolean },
    manualTotalProjects: { type: String },
    manualUniqueUsers: { type: String },
    manualTotalUsage: { type: String },
    moveToEnd: { type: Boolean },
    noRightMargin: { type: Boolean },
    noWrap: { type: Boolean },
})

const store = useStore()

const stats = ref([])
const loaded = ref(false)
const totalProjects = ref({ loaded: false, val: 0 })
const isActive = ref(false)

onMounted(() => {
    if (props.manuallySetVals) {
        totalProjects.value.val = props.manualTotalProjects
        totalProjects.value.loaded = !props.manualLoading
    }
})

watch(isActive, async (newVal, oldVal) => {
    if (newVal && !oldVal && !props.manuallySetVals) {
        store
            .dispatch('getTotalCalcProjects', { calcId: props.calcId })
            .then((res) => {
                totalProjects.value.val = res
                totalProjects.value.loaded = true
            })
        let s = await store.dispatch('getCalcStats', props.calcId)
        if (s) stats.value = s
        loaded.value = true
    }
})

watch(
    () => props.manualLoading,
    (newVal) => {
        if (newVal === false) {
            totalProjects.value.val = props.manualTotalProjects
            totalProjects.value.loaded = !props.manualLoading
            loaded.value = true
        }
    }
)

const flexClass = computed(() => {
    let cls = 'd-flex'
    if (!props.noWrap) cls += ' flex-wrap'
    if (props.moveToEnd) cls += ' justify-end'
    return cls
})

const _noLeftMargin = computed(() => !!props.noLeftMargin)

const totalUsage = computed(() => {
    if (props.manualTotalUsage) return props.manualTotalUsage
    if (!stats.value || !stats.value.total) return 0
    return compact(stats.value.total)
})

const uniqueUsers = computed(() => {
    if (props.manualUniqueUsers) return props.manualUniqueUsers
    if (!stats.value || !stats.value.users || stats.value.length === 0) return 0
    return compact(stats.value.users.length)
})

function compact(number) {
    return new Intl.NumberFormat('en', {
        notation: 'compact',
        compactDisplay: 'short',
    }).format(number)
}
</script>
